import MediaDocumentsListForCase from "@/components/Documents/MediaDocumentsListForCase.tsx";
import NoteList from "@/components/Documents/NoteList.tsx";
import AddEditProviderDialog from "@/components/Forms/AddEditProviderDialog.tsx";
import MrtProvidersTable from "@/components/Table/MrtProvidersTable.tsx";
import { Grid2 as Grid, Paper, Typography } from "@mui/material";

type Props = {
    caseIdUUID: string;
};

const ProvidersTab = ({ caseIdUUID }: Props) => {
    return (
        <Grid container sx={{ pb: { xs: "200px", md: "100px" } }}>
            <Grid size={12}>
                <Paper
                    sx={{
                        mb: 2,
                        mx: 1,
                    }}
                >
                    <Grid
                        container
                        sx={{
                            borderRadius: "8px",
                            p: 1,
                        }}
                    >
                        <Grid
                            size={12}
                            sx={{
                                p: 1,
                                mb: 1,
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography variant={"h5"}>Providers</Typography>
                            <AddEditProviderDialog caseUUID={caseIdUUID} />
                        </Grid>
                        <Grid size={12} sx={{ p: 1, mb: 1 }}>
                            <MrtProvidersTable caseIdUUID={caseIdUUID} />
                        </Grid>
                        <Grid size={6} sx={{ p: 1, mb: 1 }}>
                            <NoteList caseIdUUID={caseIdUUID} limitToCategory={"Provider"} />
                        </Grid>
                        <Grid size={6} sx={{ p: 1, mb: 1 }}>
                            <MediaDocumentsListForCase
                                caseIdUUID={caseIdUUID}
                                limitToCategory={"Providers"}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default ProvidersTab;
